module.exports = "/_next/static/images/fffb2701434a458aad26200a524504ee-cards@3x.png.webp";